// Deliberately NOT exported: ./freshpaintAnalyticsClient. Re-exporting the
// transport would let a caller build one directly through
// `@client-shared/analytics` and call `track` with no schema validation and no
// PII screening — and no lint rule would catch it, because it is neither an
// SDK import nor a global read. The transport is reachable only from inside
// this directory.
export * from "./analyticsClient";
export * from "./AnalyticsProvider";
export * from "./events";
export * from "./identity";
export * from "./noopAnalyticsClient";
export * from "./piiDenyList";
export * from "./useAnalytics";
export * from "./useAnalyticsIdentity";
